module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_moere_og_romsdal_pos.d7d4b633.svg";